import AuthenticationContext from 'adal-angular/lib/adal.js'

const endpoints = {
    // Necessary for CORS requests, for more info see https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/CORS-usage
    "https://api.hockenbergs.com/api": "f927bef1-9285-4883-8b5f-4a486b693fc6"
}

const config = {
    tenant: 'c305d23e-7377-424c-b3bc-0254f5e6e053',
    clientId: '29bd90b6-80f6-4a08-91f8-c1156edd6c42',
    redirectUri: 'https://staff.hockenbergs.com',
    cacheLocation: 'localStorage',
    endpoints: endpoints
};

export default {
    authenticationContext: null,
    /**
     * @return {Promise}
     */
    initialize() {
        this.authenticationContext = new AuthenticationContext(config);

        return new Promise((resolve, reject) => {
            if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
                // redirect to the location specified in the url params.
                this.authenticationContext.handleWindowCallback();
            }
            else {
                // try pull the user out of local storage
                let user = this.authenticationContext.getCachedUser();

                if (user) {
                    resolve();
                }
                else {
                    // no user at all - go sign in.
                    //this.signIn();
                    resolve();
                }
            }
        });
    },
    /**
     * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
     */
    acquireToken() {
        return new Promise((resolve, reject) => {
            //     var token = this.authenticationContext.getCachedToken(config.clientId)
            //     if (token) resolve(token)
            //     else reject('Unable to load token') ""
            this.authenticationContext.acquireToken("f927bef1-9285-4883-8b5f-4a486b693fc6", (error, token) => {
                if (error || !token) {
                    return reject(error);
                } else {
                    return resolve(token);
                }
            });
        });
    },
    /**
     * Issue an interactive authentication request for the current user and the api resource.
     */
    acquireTokenRedirect() {
        this.authenticationContext.acquireTokenRedirect(endpoints.api);
    },
    /**
     * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
     */
    isAuthenticated() {
        // getCachedToken will only return a valid, non-expired token.
        if (this.authenticationContext.getCachedToken(config.clientId)) { return true; }
        return false;
    },
    /**
     * @return An ADAL user profile object.
     */
    getUserProfile() {

        return this.authenticationContext.getCachedUser().profile;
    },
    signIn() {
        this.authenticationContext.login();
    },
    signOut() {
        this.authenticationContext.logOut();
    }
}